<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">申请使用 / 外带印章</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回</a>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="140px" class="form">
          <el-form-item label="所属公司">
            <el-select size="small" class="organization-select" v-model="form.depId" placeholder="请选择所属公司">
              <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="印章名称">
            <el-select size="small" @change="currentSeal" class="organization-select" v-model="form.sealId"
              placeholder="请选择印章">
              <el-option v-for="item in sealListData" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请内容">
            <el-radio v-model="form.type" label="0">使用</el-radio>
            <el-radio v-model="form.type" label="1">外带</el-radio>
          </el-form-item>
          <el-form-item label="申请时间">
            <el-date-picker v-model="form.useTime" size="small" value-format="yyyy-MM-dd" type="date"
              placeholder="选择申请印章的时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="归还时间" v-if="form.type==1">
            <el-date-picker v-model="form.returnTime" size="small" value-format="yyyy-MM-dd" type="date"
              placeholder="选择归还印章的时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="申请事由">
            <el-input type="textarea" :rows="3" placeholder="请输入申请原因" v-model="form.remark"></el-input>
          </el-form-item>

          <div class="tip" style="margin:20px 0 0 40px">
            * 相关附件
          </div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments :projectId="form.projectId" :contractId="form.contractId" ref="attachments"
                :arr="attachmentArr" :type='990'></attachments>
            </el-form-item>
          </div>

          <div class="tip" style="margin:30px 0 -10px 50px;">
            * 意见与审批
          </div>
          <div class="clear label-mx">
            <el-form-item label="审批方式">
              <div class="approve">
                <el-radio v-model="form.approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="form.approvalType" label="1">平行审批</el-radio>
              </div>
            </el-form-item>
            <div class="approval-tip">
              <p><a href="javascript:;" style="color:#d93c37;text-decoration: underline;"
                  @click="showSealStatus=true">不清楚如何选择审批人？ 点击查看如何添加审批人</a></p>
            </div>

            <!-- 审批 -->
            <approval-item-by-custom ref="approval" :defaultApprovalUsers="defaultApprovalUsers" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item-by-custom>

          </div>

          <el-form-item label="">
            <el-button @click="createOperate()" v-loading="loading" class="form-btn" type="success">确认提交申请</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </div>

    <!-- 审批人说明弹窗 -->
    <div class="pop-room pop-seal-img-info" v-if="showSealStatus">
      <h3 class="title">审批领导选择说明</h3>
      <a href="javascript:;" @click="showSealStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <div class="readme-intro-cont" v-html="sealReadIntro">

        </div>
        <!-- 说明图片 -->
        <!-- <img :src="SealReadMeUrl" width="750" alt="" /> -->
      </div>
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  // import approvalUsers from '@/Mixins/approvalUsers'

  import ApprovalItemByCustom from '../../components/ApprovalItemByCustom'
  import Attachments from '@/components/Attachments'
  export default {
    computed: {
      ...mapState({
        userData: state => state.main.userData,
        organization: state => state.main.organization,
        contactSelectArr: state => state.main.contactSelectArr,
      })
    },
    // mixins: [approvalUsers],
    data() {
      return {
        showSealStatus: false,
        SealReadMeUrl: '',
        sealReadIntro: '',
        // sealImg: require(''),

        organizationListData: [],
        sealListData: [],
        loading: false,
        form: {
          depId: "",
          type: "0",
          useTime: "",
          returnTime: "",
          sealId: "",
          remark: "",

          approvalType: "0",
          approvalUserIds: "",
        },

        attachmentArr: [],
        applyInfo: '',

        defaultApprovalUsers: "",
        selectArr: [],
        approvalSetDep: {},
      }
    },
    created() {
      // this.setSelectArr(this.applyInfo, 0)
    },
    mounted() {
      this.organizationListData = this.organization[0].childDepts
      this.form.depId = this.userData.secDepIds.split(",")[0] / 1
      this.form.useTime = this.form.returnTime = util.getFormatDate()

      this.getSealListData()

      if (this.$route.query.applyId) {
        this.form.applyId = this.$route.query.applyId / 1
        this.formLoading = true
        this.getApplyInfo()
      }

      // 获取印章的使用说明，根据公司获取
      this.getReadMeUrl()

    },
    components: {
      ApprovalItemByCustom,
      Attachments,
    },
    methods: {
      // 获取印章的使用说明，根据公司获取
      getReadMeUrl() {
        ajax.get('/seal/approval/example/' + this.form.depId, '', res => {
          this.sealReadIntro = res.vo.intro
        })
      },
      // 获取原审批表内容
      getApplyInfo() {
        ajax.get('/seal/apply/info/', {
          applyId: this.form.applyId,
          type: 0
        }, (res) => {
          this.applyInfo = res.vo

          this.form = this.applyInfo
          this.form.applyId = this.form.flow.applyId

          this.form.applyType = this.form.type
          this.attachmentArr = this.applyInfo.attachments ? this.applyInfo.attachments : []

          this.selectArr = this.form.flow.approvals.map(item => item.user)
          this.formLoading = false
        })
      },
      // 显示印章审批人说明图片
      showSealImage() {

      },
      // 选择了印章
      currentSeal(sealId) {
        let seal = this.sealListData.find((item) => {
          return item.id == sealId
        })
        this.defaultApprovalUsers = []
        if (seal.leader) {
          this.defaultApprovalUsers.push(seal.leader)
        }
      },
      getSealListData() {
        ajax.get('/seal/list', {
          depId: this.form.depId
        }, (res) => {
          this.sealListData = res.vo.array
        })
      },
      createOperate() {
        if (!this.form.sealId || !this.form.remark) {
          this.$message.error("使用/外带印章的原因必填")
          return
        }

        this.form.approvalUserIds = this.$refs.approval.getUserIds()
        // 暂时取消固定审批人
        // if (this.defaultApprovalUsers.length > 0) {
        //   this.form.approvalUserIds += "," + this.defaultApprovalUsers[0].id
        // }
        if (!this.form.approvalUserIds) {
          this.$message.error('审批人员不能一个都不选择')
          return
        }

        this.form.attachments = this.$refs.attachments.getAttachments()

        let _url = !this.form.applyId ? '/seal/use/approval' : '/seal/use/approval/edit'

        this.loading = true
        ajax.post(_url, this.form, (res) => {
          this.loading = false
          this.$message.success("使用或外带印章申请提交成功")
          this.$router.back()
        })
      },
    },
    watch: {
      "form.depId"() {
        // 获取对应公司的印章
        this.getSealListData()
        // 获取印章的使用说明，根据公司获取
        this.getReadMeUrl()
      },
      contactSelectArr() {
        switch (this.userType) {
          case 1:
            this.selectArr1 = this.contactSelectArr
            break;
          case 2:
            this.selectArr2 = this.contactSelectArr
            break;
          case 3:
            this.selectArr3 = this.contactSelectArr
            break;
        }
      },
    },
    // beforeRouteLeave(to, from, next) {
    //   next()
    // },
  };
</script>


// WEBPACK FOOTER //
// src/page/seal/create.vue